import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AnalyticsActions } from 'store/models/analytics'
import { VouchersActions } from 'store/models/vouchers'
import { AllVouchers } from './AllVouchers'
import { VouchersTable } from './VouchersTable'

export const Vouchers = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(VouchersActions.getVouchers())
        dispatch(VouchersActions.getVouchersDetails())
        dispatch(AnalyticsActions.postAnalytics('[Vouchers] componentDidMount', null))
    }, [])

    return (
        <>
            <div className="module">
                <div className="module-header">
                    <div>
                        <h2>Vouchers by pricing options</h2>
                        <h3>Click the + button next to the rows with low vouchers and follow the instructions to upload new voucher codes.</h3>
                    </div>
                </div>
                <VouchersTable />
            </div>
            <AllVouchers />
        </>
    )
}
